import { render, staticRenderFns } from "./EmptySearch.vue?vue&type=template&id=17d9649a&"
import script from "./EmptySearch.vue?vue&type=script&lang=js&"
export * from "./EmptySearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SearchForm: require('/Users/eralpsoftwareweb/Desktop/Active Projects/Heocademy/Gökçe Özel/gokce-ozel-nuxt/components/Search/SearchForm.vue').default})
